import { useTheme } from '@emotion/react';
import { Box, Grid, Stack, useMediaQuery } from '@mui/material';
import {
  MarketMetricsGraphFour,
  MarketMetricsGraphOne,
  MarketMetricsGraphThree,
  MarketMetricsGraphTwo,
} from './MarketMetricsGraph';

export const MarketMetrics = () => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.between(900, 1200));
  const matchesone = useMediaQuery(theme.breakpoints.down('md'));
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      sx={{
        padding: matchessm ? '10px 0' : '20px 0',
        mt: '10px',
      }}
    >
      <Stack
        sx={{
          display: 'flex',
          flexDirection: 'row',
          gap: '16px',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
        }}
      >
        <Grid
          sx={{
            width: matchesone ? '100%' : matches ? '48%' : '23.8%',
            display: 'flex',
          }}
        >
          <MarketMetricsGraphOne />
        </Grid>
        <Grid
          sx={{
            width: matchesone ? '100%' : matches ? '48%' : '23.8%',
            display: 'flex',
          }}
        >
          <MarketMetricsGraphTwo />
        </Grid>
        <Grid
          sx={{
            width: matchesone ? '100%' : matches ? '48%' : '23.8%',
            display: 'flex',
          }}
        >
          <MarketMetricsGraphThree />
        </Grid>
        <Grid
          sx={{
            width: matchesone ? '100%' : matches ? '48%' : '23.8%',
            display: 'flex',
          }}
        >
          <MarketMetricsGraphFour />
        </Grid>
      </Stack>
        {/* <Grid
      container 
      // gap={1}
      sx={{
        // p: 1,
        marginTop: "15px",
        display: "flex",
        // flexDirection: "row",
        backgroundColor: "#FFFFFF",
        // border: "0.5px solid #E4E4E4",
        paddingBottom:"16px",
        // width: "100%",
        // height: "315px",
        // height:'100%',
        // height:'100%',
        borderRadius: "5px",
        justifyContent:'space-between',
      }}
    > */}
        {/* <Grid sx={{width:"221px", height:"111px"}}>
        <Matrics />   
      </Grid>
      <Grid sx={{marginTop:"20px"}}>
      <Typography style={{marginLeft:"40px"}} sx={{...poppins500, fontSize:"20px"}}>Auction Clearance</Typography>
      </Grid>
      <Grid sx={{marginTop:"10px",display:"flex", gap:"30px", marginLeft:"10px"}}>
        <Box sx={{}}>
            <Typography sx={{...poppins400, fontSize:"16px"}}>Auction Results - 2026</Typography>     
            </Box>
        <Box>
        <Typography>87</Typography>
        </Box>
      </Grid>
      <Grid  sx={{marginTop:"10px",display:"flex", gap:"105px", marginLeft:"10px"}}>
        <Box>
            <Typography sx={{...poppins400, fontSize:"16px"}}>Private Sales</Typography>
        </Box>
        <Box>
        <Typography>30</Typography>
    </Box>
      </Grid> */}
        {/* <Grid item lg={3} xs={12} sm={6}>
       <MarketMetricsGraphOne />
      </Grid>
      <Grid item lg={3} xs={12} sm={6}>
              <MarketMetricsGraphTwo />
      </Grid>
      <Grid item lg={3} xs={12} sm={6}>
              <MarketMetricsGraphThree />
      </Grid>
      <Grid item lg={3} xs={12} sm={6}>
              <MarketMetricsGraphFour />
      </Grid>
    </Grid> */}
    </Box>
  );
};
